import React, {useLayoutEffect, useRef} from 'react';

import css from './sheet.module.css';

type Props = {
	children: React.ReactNode;
};

function fitCard(card: Element) {
	const grid = card.parentElement;
	if (!grid || !(card instanceof HTMLElement)) return;
	const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
	card.style.gridRowEnd = `span ${Math.ceil(card.getBoundingClientRect().height + gap)}`;
}

/**
 * плашки разной высоты в несколько столбцов без пустот: строки грида по 1px, каждая плашка занимает
 * столько строк, какова её высота вместе с отступом
 */
export const CardGrid: React.FC<Props> = ({children}) => {
	const gridRef = useRef<HTMLDivElement>(null);
	const observerRef = useRef<ResizeObserver | undefined>(undefined);

	useLayoutEffect(() => {
		const observer = new ResizeObserver((entries) => entries.forEach(({target}) => fitCard(target)));
		observerRef.current = observer;
		return () => observer.disconnect();
	}, []);

	useLayoutEffect(() => {
		Array.from(gridRef.current?.children || []).forEach((card) => {
			fitCard(card);
			observerRef.current?.observe(card);
		});
	});

	return (
		<div ref={gridRef} className={css.abilities}>
			{children}
		</div>
	);
};
